

import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import { getResponseMessage } from "../../../utils";
import axiosRequest from "../universal/axiosService";

// export const fetchWorkauths = async (params) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.get(ENDPOINTS.WORK_AUTHS.GET_ALL, {
//       params: {
//         coll: "WorkAuth",
//         lim: params.limit,
//         'ref':'Document',
//         pg: params.page,
//         fil: JSON.stringify(params.fil),
//         cache: params.cache,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`, // Add authorization header
//         "Content-Type": "application/json",
//       },
//       withCredentials: true, // Include cookies if using session-based auth
//     });
//     return response.data;
//   } catch (error) {
//     console.error(error);
//     //throw error;
//     // showToast("No Data available", "error", 5000);
//   }
// };

//add WorkAuth
export const fetchWorkauths = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.WORK_AUTHS.GET_ALL,
    params: {
      coll: "WorkAuth",
      lim: params.limit,
      ref: "Document",
      pg: params.page,
      fil: JSON.stringify(params.fil),
      cache: params.cache,
    },
  });
};

// export const addNewWorkAuth = async (workAuthData) => {
//   try {
//     const token = localStorage.getItem("token");
//     const response = await axios.post(
//       ENDPOINTS.WORK_AUTHS.ADD_NEW,
//       {
//         coll: "WorkAuth",
//         payload: {
//           ...workAuthData,
//         },
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );

//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     //console.error("Error adding work authorization:", error);
//     showToast(getResponseMessage(error.response.data.sm), "error", 5000); // Add logging
//     return {
//       success: false,
//       error: error.message || "Failed to add work authorization",
//     };
//   }
// };
export const addNewWorkAuth = async (workAuthData) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.WORK_AUTHS.ADD_NEW,
    data: {
      coll: "WorkAuth",
      payload: { ...workAuthData },
    },
  });
};

//mahender
// export const updateWorkAuth=async( coll,
//   uiid,
//   payload,)=>{
//     try {
//       const token = localStorage.getItem("token");
//       console.log(
//         "payload update  Employee",
//         coll,
//         uiid,
//         payload,
//       );
//       const params = new URLSearchParams({
//         coll,
//         uiid,
//       });
//       const response = await axios.patch(
//         //`${ENDPOINTS.EMPLOYEES.UPDATE}?coll=${coll}&uiid=${uiid}`,
//         `${ENDPOINTS.WORK_AUTHS.UPDATE}?${params.toString()}`,
//         { payload:[ {"type": "SET",value:payload}]},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         }
//       );
//       return {
//         success: true,
//         data: response.data?.data?.doc,
//       };
//     } catch (error) {
//       console.error("Error updating employee:", error);
//       return {
//         success: false,
//         error: error.message || "Failed to update employee",
//       };
//     }
// }

export const updateWorkAuth = async (coll, uiid, payload) => {
  const params = { coll, uiid };
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.WORK_AUTHS.UPDATE,
    params,
    data: {
      payload: [{ type: "SET", value: payload }],
    },
  });
};

